import { defineComponent } from "vue";
export default defineComponent({
    name: 'g-color-badge',
    props: {
        variant: {
            type: String,
            required: false,
            default: 'default'
        },
        color: {
            type: String,
            required: false,
            default: ''
        },
        rounded: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        colorStyle() {
            if (!this.color.length) {
                return '';
            }
            return `background:${this.color}`;
        },
        variantClass() {
            return {
                [`is--${this.variant}`]: true,
                'is--rounded': this.rounded
            };
        }
    }
});
